import React from "react";
import { useNotification } from "../../hooks/useNotification";
import { Download, File } from "lucide-react";

const LinkifyText = ({ text, isFile, file, isUndo, isSelf }) => {
  const { addNotification } = useNotification();

  if (!text)
    return (
      <p className={isSelf ? "text-gray-200" : "text-gray-500"}>
        {isUndo ? "Tin nhắn đã được thu hồi" : text}
      </p>
    );

  // Regular expression to match URLs
  const urlRegex =
    /(http:\/\/[^\s]+|https:\/\/[^\s]+|www\.[^\s]+|[^\s]+\.[a-z]{2,})/gi;

  // Regular expression to match phone numbers
  // This regex assumes very simple patterns for phone numbers. Adjust as needed for your use case
  const phoneRegex =
    /(\+?\d{1,3}[-.\s]?)?(\(?\d{3}\)?[-.\s]?)\d{3}[-.\s]?\d{4}/g;

  // Function to copy text to clipboard
  const copyToClipboard = (text) => {
    navigator.clipboard
      .writeText(
        text.replaceAll(".", "").replaceAll("-", "").replaceAll("+", "")
      )
      .then(
        () => {
          addNotification("Đã copy", 1);
        },
        (err) => {
          console.error("Could not copy text: ", err);
        }
      );
  };

  return isUndo ? (
    <p className={isSelf ? "text-gray-200" : "text-gray-500"}>
      Tin nhắn đã được thu hồi
    </p>
  ) : (
    <p>
      {isFile ? (
        <div className="flex gap-1 items-center">
          <File className="w-12 h-12" />
          <div className="flex flex-col gap-2 w-3/4">
            <p>{text}</p>
            <a
              key={file}
              href={file}
              rel="noopener noreferrer"
              className="flex justify-end"
              title="Tải xuống"
            >
              <Download className="w-4 h-4 bg-white text-gray-500 rounded" />
            </a>
          </div>
        </div>
      ) : (
        text.split(/(\s+)/).map((part, index) => {
          // Check if the part is a URL
          if (urlRegex.test(part)) {
            const url = part.startsWith("http") ? part : `http://${part}`;
            return (
              <a
                key={`url-${index}`}
                href={url}
                target="_blank"
                rel="noopener noreferrer"
                className="underline"
              >
                {part}
              </a>
            );
          }

          // Check if the part is a phone number
          if (phoneRegex.test(part)) {
            return (
              <span
                key={`phone-${index}`}
                className="cursor-pointer bg-red-600 rounded-md px-1 text-white"
                onClick={(e) => {
                  e.preventDefault();
                  copyToClipboard(part);
                }}
              >
                {part}
              </span>
            );
          }

          // Return the part as is if it's neither a URL nor a phone number
          return part;
        })
      )}
    </p>
  );
};

export default LinkifyText;
